/* eslint-disable no-useless-escape */
import {
    ExtendedFieldId,
    Validator,
    ExtendedErrorId,
    setCustomValidator,
    FieldContent,
} from '@sheerid/jslib';

export const optionalEmailValidator = () => {
    const optionalEmail: ExtendedFieldId = 'personal-email';

    const getOptionalEmailValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidOptionalEmail';
        // tslint:disable-next-line:max-line-length
        const VALID_EMAIL_REGEXP = /(^\s*?[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+)*@([A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+)+|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])\s*?$)/;

        if (!value) {
            return;
        }

        if (!VALID_EMAIL_REGEXP.test(value.toString())) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(optionalEmail, getOptionalEmailValidationError);
};
